<template>
    <div class="simple-filters" >
        <button class="simple-filters__button simple-filters__button--white-line button button--clear"
            :aria-expanded="showEventFilters"
            aria-controls="event-filters"
            @click="toggleEventFilters">
            <h3 class="filter-heading filter-heading--simple">Händelser</h3>
            <span class="icon" :class="{ 'icon--minus': showEventFilters, 'icon--plus': !showEventFilters }"></span>
        </button>
        <div v-if="showEventFilters" id="event-filters" class="filter-section">
            <div class="filter-section__filters">
                <DropdownFilter :dataKey="['name','alternateNames']" placeholder="Välj namn" title="Namn" />
                <DropdownFilter dataKey="type" placeholder="Välj typ" title="Typ" />
                <IntervalFilter dataKey="launchDate" title="Sjösatt/Infört i flottan" />
                <IntervalFilter dataKey="displacement" title="Ton" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import DropdownFilter from '@/components/filter/DropdownFilter.vue';
import IntervalFilter from '@/components/filter/IntervalFilter.vue';

const showEventFilters = ref(true);

const toggleEventFilters = () => {
    showEventFilters.value = !showEventFilters.value;
}

</script>
